import React from 'react'

const Radio = ({ width = 20, height = 20, selected = false }) =>
  selected ? (
    <svg width={width} height={height} viewBox="0 0 20 20">
      <g transform="translate(-862 -385)">
        <g transform="translate(862 385)" fill="none">
          <path d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z" stroke="none" />
          <path
            d="M 10 2 C 5.588789939880371 2 2 5.588789939880371 2 10 C 2 14.41121006011963 5.588789939880371 18 10 18 C 14.41121006011963 18 18 14.41121006011963 18 10 C 18 5.588789939880371 14.41121006011963 2 10 2 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z"
            stroke="none"
            fill="#b18935"
          />
        </g>
        <rect
          width="8"
          height="8"
          rx="4"
          transform="translate(868.188 391)"
          fill="#b18935"
        />
      </g>
    </svg>
  ) : (
    <svg width={width} height={height} viewBox="0 0 20 20">
      <g transform="translate(-862 -385)">
        <g transform="translate(862 385)" fill="none">
          <path d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z" stroke="none" />
          <path
            d="M 10 2 C 5.588789939880371 2 2 5.588789939880371 2 10 C 2 14.41121006011963 5.588789939880371 18 10 18 C 14.41121006011963 18 18 14.41121006011963 18 10 C 18 5.588789939880371 14.41121006011963 2 10 2 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z"
            stroke="none"
            fill="#b18935"
          />
        </g>
      </g>
    </svg>
  )

export default Radio
